import React from "react";
import {Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./Error.css";

function EmbeddedError() {

    const navigate = useNavigate();

    const reset = () => {        
        navigate("/");
    }

    return (                
        <Container className="coreContent">
            <Row className="mb-4">
            <Col>
                <div className="error-message">
                    Something went wrong
                </div>
            </Col>
            </Row>
            <Row>         
            <Col>  
            <Button onClick={reset}>Try again</Button>
            </Col>
            </Row>
        </Container>            
    );
}

export default EmbeddedError;
